<template>
    <div>
        <b-modal v-if="step != 'upload'" v-model="visible" hide-header hide-footer no-fade modal-class="b-modal-in-upload" dialog-class="b-dialog-in-upload" content-class="b-content-in-upload">
            <a-spin :tip="$t('Loading...')" :spinning="getting_data">
                <div v-on-clickaway="cancel">
                    <div class="d-block">
                        <div class="row">
                            <div class="col-12 text-center">
                                <span class="fs-20 black fw-600" style="display: block">{{ step }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 text-center">
                                <form enctype="multipart/form-data" novalidate>
                                    <div v-if="item && item.image">
                                        <img :src="item.image" style="max-width: 100%; max-height: 50vh; padding: 10px" />
                                        <div class="remove-image color-white fs-20" @click="removeImage(item)">x</div>
                                    </div>
                                    <div class="dropbox" v-else>
                                        <input
                                            type="file"
                                            multiple
                                            :name="step"
                                            :disabled="false"
                                            @change="
                                                // filesChange($event.target.name, $event.target.files);
                                                // fileCount = $event.target.files.length;
                                                onFileChange(item, $event)
                                            "
                                            accept="image/*"
                                            class="input-file"
                                        />
                                        <p>
                                            <a-icon type="upload" :style="{ color: '#000000', fontSize: '60px' }" /><br />
                                            <span class="fs-18 black fw-600" style="display: block">อัปโหลดรูปภาพ</span>
                                        </p>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 text-center" v-if="item && item.image">
                                <span class="fs-18 black fw-600" style="display: block">สถานะ : {{ imageStatus ? 'อยู่ระหว่างการอนุมัติเอกสาร' : 'เอกสารได้รับการอนุมัติแล้ว' }}</span>
                                <span class="fs-18 black" style="display: block">หากท่านต้องการอัปโหลดเอกสารใหม่ กรุณากด x ที่มุมบนขวาของรูปภาพ แล้วอัปโหลดเอกสารอีกครั้ง</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 text-center">
                                <a-button size="large" class="text-center primary-btn ant-button-label-custom" style="width: 47.5%; margin-top: 14px" :loading="false" @click="cancel">
                                    <strong class="fs-18">&nbsp;{{ $t('ปิดหน้าต่าง') }}</strong>
                                </a-button>
                            </div>
                        </div>
                    </div>
                </div>
            </a-spin>
        </b-modal>
    </div>
</template>
<script>
import { directive as onClickaway } from 'vue-clickaway';
import store from 'store';
import _ from 'lodash';
export default {
    props: ['visible', 'step', 'init_doc'],
    computed: {
        item: function () {
            return { image: this.init_doc && this.init_doc.file };
        },
        attach_label_id: function () {
            return this.init_doc.attach_label_id;
        },
        imageStatus() {
            return _.get(this.init_doc, 'display_upload_btn');
        },
    },
    data() {
        return {
            getting_data: false,
            password: store.get('password_ticket'),
            key: store.get('key_ticket'),
        };
    },
    mounted() {
        console.log('init_doc', this.init_doc);
    },
    methods: {
        cancel() {
            this.$emit('on-cancel');
            this.item.image = false;
        },
        handleStep(doc) {
            this.attach_label_id = doc.attach_label_id;
            this.item.image = doc.file;
            this.$emit('handle-step', doc);
        },
        onFileChange(item, e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.createImage(item, files[0]);
        },
        createImage(item, file) {
            var reader = new FileReader();
            reader.onload = (e) => {
                item.image = e.target.result;
            };
            reader.readAsDataURL(file);
            const form_data = new FormData();
            form_data.append('ticket_id', this.init_doc.ticket_id);
            form_data.append('attach_label_id', this.attach_label_id);
            form_data.append('attach_file', file);
            this.getting_data = true;
            this.$store.dispatch('user/POST', {
                payload: {
                    path: '/api/log/activity/attach-file',
                    data: form_data,
                    callback: (res) => {
                        if (res && res.result == 'errors') {
                            const error = {
                                title: '',
                            };
                            for (const [key, value] of Object.entries(res.errors)) {
                                console.log('value', value);
                                if (key) {
                                    error.title = value[0];
                                }
                            }
                            this.$alert('ระบบบันทึกข้อมูลไม่เรียบร้อย', 'อัปโหลดรูปภาพไม่สำเร็จ', null, {
                                confirmButtonText: 'ยืนยัน',
                                customClass: 'normal-alert-ok-btn',
                            });
                        } else {
                            const complete = {
                                message: '',
                            };
                            for (const [key, value] of Object.entries(res.complete.msg)) {
                                console.log('value', value);
                                if (key) {
                                    complete.message = value;
                                }
                            }
                            this.$alert('ระบบบันทึกข้อมูลเรียบร้อยแล้ว', 'อัปโหลดรูปภาพสำเร็จ', null, {
                                confirmButtonText: 'ยืนยัน',
                                customClass: 'normal-alert-ok-btn',
                            });
                        }
                        this.getting_data = false;
                    },
                },
            });
        },
        removeImage: function (item) {
            this.getting_data = true;
            this.$store.dispatch('user/POST', {
                payload: {
                    path: '/api/log/activity/delete-attach-file',
                    data: {
                        ticket_id: this.init_doc.ticket_id,
                        attach_label_id: this.attach_label_id,
                    },
                    callback: (res) => {
                        if (res && res.result == 'errors') {
                            const error = {
                                title: '',
                            };
                            for (const [key, value] of Object.entries(res.errors)) {
                                if (key) {
                                    console.log('value[0]', value[0]);
                                    error.title = value[0];
                                }
                            }
                        } else {
                            item.image = false;
                            const complete = {
                                message: '',
                            };
                            for (const [key, value] of Object.entries(res.complete.msg)) {
                                console.log('value', value);
                                if (key) {
                                    complete.message = value;
                                }
                            }
                        }
                        this.getting_data = false;
                    },
                },
            });
        },
    },
    directives: {
        onClickaway: onClickaway,
    },
};
</script>
<style>
.modal {
    z-index: 100000 !important;
}
.modal .modal-content {
    margin: 0px !important;
}
</style>
<style scoped>
/deep/ .b-modal-upload {
    max-width: 100%;
    margin: 0;
    top: unset;
    bottom: 0;
    left: unset;
    right: unset;
    height: unset;
    /* display: flex !important; */
    position: fixed;
    padding: 0 !important;
}
/deep/ .b-dialog-upload {
    margin: 0 auto;
}
/deep/ .b-content-upload {
    border-radius: 0;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
}
/deep/ .b-modal-in-upload {
    width: 100%;
    height: 100%;
}
/deep/ .b-dialog-in-upload {
    margin: 0 auto;
    height: 100%;
}
/deep/ .b-content-in-upload {
    border-radius: 0;
    min-height: 100vh;
}
.center {
    margin: auto;
    width: 80%;
}
.green {
    color: green;
}
.dropbox {
    outline: 2px dashed grey; /* the dash box */
    outline-offset: -10px;
    /* background: lightcyan; */
    color: dimgray;
    padding: 10px 10px;
    min-height: 20vh; /* minimum height */
    position: relative;
    cursor: pointer;
}
.input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 50vh;
    position: absolute;
    cursor: pointer;
}
.dropbox:hover {
    /* background: lightblue; */
}
.dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 14vh 0;
}
.remove-image {
    background: #cc0000;
    width: 48px;
    height: 48px;
    line-height: 42px;
    position: absolute;
    top: 3vh;
    right: 6.325vw;
}
@media screen and (max-width: 480px) {
    .remove-image {
        right: 25px;
    }
}
</style>
